/// <reference types="bootstrap"/>
import BootstrapScrollBarHelper from 'bootstrap/js/dist/util/scrollbar';
class ScrollBarHelper {
    constructor(config) {
        this.config = config;
        this.instance = this.createInstance();
    }
    createInstance() {
        return new BootstrapScrollBarHelper({});
    }
    getInstance() {
        return this.instance;
    }
    hide() {
        this.instance.hide();
    }
    reset() {
        this.instance.reset();
    }
}
export { ScrollBarHelper };
